import Software from './models/Software'
import { createSoftware, updateSoftware, loadSoftware, 
  runVulnerabilityUpdate, runVersionUpdate, loadSoftwareList,
  loadDistributions, saveDistribution, updateDistribution
} from '@/api/super'

let softwareModel = new Software

export default {

  namespaced: true,

  state: {
    software: softwareModel,
    list: []
  },

  mutations: {
    ...softwareModel.mutations(),
    setList: (state, list) => state.list = list
  },

  actions: {
    store: ({ state }) => new Promise((resolve, reject) => createSoftware(state.software, resolve, reject)),
    update: ({ state }) => new Promise((resolve, reject) => updateSoftware(state.software, resolve, reject)),
    runVulnerabilityUpdate: ({ }, softwareId) => new Promise((resolve, reject) => runVulnerabilityUpdate(softwareId, resolve, reject)),
    runVersionUpdate: ({ }, softwareId) => new Promise((resolve, reject) => runVersionUpdate(softwareId, resolve, reject)),
    loadSoftware: ({ commit }, softwareId) => new Promise((resolve, reject) => loadSoftware(softwareId, ({data}) => {
      commit('setSoftware', data)
      resolve()
    }, reject)),
    loadSoftwareList: ({ commit }) => new Promise((resolve, reject) => loadSoftwareList(({ data }) => {
      commit('setList', data)
      resolve()
    }, reject)),
    loadDistributions: ({ commit }, softwareId) => new Promise((resolve, reject) => loadDistributions(softwareId, ({ data }) => {
      commit('setDistributions', data)
      resolve()
    }, reject)),
    saveDistribution: ({ commit }, softwareId) => new Promise((resolve, reject) => saveDistribution(softwareId, ({ data }) => {
      commit('setDistributions', data)
      resolve()
    }, reject)),
    updateDistribution: ({ commit }, softwareId) => new Promise((resolve, reject) => updateDistribution(softwareId, ({ data }) => {
      commit('setDistributions', data)
      resolve()
    }, reject)),
  },

  getters: {
    software: state => state.software,
    softwareList: state => state.list,
  }

}